module.exports = __webpack_public_path__ + "img/shengcun2.f1f29cd5.png";